export default "/images/man.webp?28511e2ef186e83288874c440c19ebdc";